import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV_OPTIONS } from '@up/shared/injection-tokens';
import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SendInBlueService {
  readonly API_KEY = 'send-in-blue';
  readonly API_URL = `${this.environmentOptions.apiUrl}/${this.API_KEY}`;

  constructor(
    @Inject(ENV_OPTIONS) private environmentOptions: any,
    private http: HttpClient
  ) {}

  public sendEmail(pdfAsString: string, emailAddress: string) {
    const url = `${this.API_URL}`;
    return this.http
      .post(url + `/send-email-with-attachment`, {
        encodedFile: pdfAsString,
        emailAddress: emailAddress,
        filename: 'Receipt.pdf',
        emailTextContent: 'Please find attached the receipt for your order.',
        emailSubject: 'Customer Receipt'
      })
      .pipe(
        map((data) => data),
        catchError(this.handleError)
      );
  }

  private handleError(res: HttpErrorResponse | any) {
    console.error(res.error || res.body.error);
    return observableThrowError(res.error || 'Server error');
  }
}
